<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Notifications') }}</h4>
        </div>
      </div>
    </div>

    <creating
      v-if="creating"
      height="100%" />

    <div
      v-if="!creating"
      class="vflex-row-1 p-3">
      <form class="shurt-conatiner" v-on:submit.prevent="saveNotify(receive_notifications)">
        <table class="table table-bordered" style="width: auto">
          <thead>
            <tr>
              <th scope="col">{{ $t('Notification') }}</th>
              <th scope="col">Web Browser</th>
              <th scope="col">{{ $t('Email') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(key, index) in Object.keys(receive_notifications)"
              :key="index">
              <th scope="row">{{ receive_notifications[key]['name'] }}</th>
              <td class="select-field">
                <input type="checkbox" v-model="receive_notifications[key]['web']">
              </td>
              <td class="select-field">
                <input type="checkbox"  v-model="receive_notifications[key]['email']">
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </div>

    <div
      v-if="!creating"
      class="vflex-row-0 vflex-footer p-3">
      <button
        :class="{'box-loading': loading}"
        type="button"
        class="btn btn-primary"
        @click="saveNotify(receive_notifications)">
        {{ $t('Save') }}
        </button>
    </div>
    
  </div>

</template>

<script>
export default {
  name: 'Notify',
  components: {
  },
  data () {
    return {
      creating: true,
      loading: false,
      receive_notifications: null
    }
  },
  computed: {
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$store
      .dispatch('getNotificationSettings')
      .then(result => {
        this.receive_notifications = this.getNotify(result)
        this.creating = false
      })
    },
    saveNotify (receiveNotifications) {
      this.loading = true

      this.$store
      .dispatch('updateNotificationSettings', receiveNotifications)
      .then(result => {
        this.receive_notifications = this.getNotify(result)
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    getNotify (receiveNotifications) {
      const map = {
        note_mention: {
          name: this.$t('Mentioned in a note'),
          web: false,
          email: false
        },
        share_candidate_created: {
          name: this.$t('New share'),
          web: false,
          email: false
        },
        evaluation_created: {
          name: this.$t('New evaluation'),
          web: false,
          email: false
        },
        questionnaire_created: {
          name: this.$t('Questionnaire answered'),
          web: false,
          email: false
        },
        intervideo_created: {
          name: this.$t('Video interview answered'),
          web: false,
          email: false
        },
        task_reminder: {
          name: this.$t('Task reminder'),
          web: false,
          email: false
        },
        requisition_created: {
          name: this.$t('New requisition'),
          web: false,
          email: false
        },
        requisition_approvalflow_finished: {
          name: this.$t('Finalizing the requisition approval workflow'),
          web: false,
          email: false
        },
        note_created: {
          name: this.$t('New note'),
          web: false,
          email: false
        },
        candidate_qualified: {
          name: this.$t('Candidate requalified'),
          web: false,
          email: false
        },
        candidate_disqualified: {
          name: this.$t('Disqualified candidate'),
          web: false,
          email: false
        },
        joblog_created: {
          name: this.$t('Note added to job'),
          web: false,
          email: false
        }
      }
      for (var key in map) {
        map[key] = {
          ...map[key],
          ...receiveNotifications[key]
        }
      }
      return map
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Notify/Notify.vue